export default class Document {
	constructor(styles, jsx, dateLastUpdated) {
		this.styles = styles;
		this.jsx = jsx;
		this.dateLastUpdated = dateLastUpdated;
	}
}
